import React, { Component } from 'react';
import { withTranslation } from "react-i18next";

import { checkUndefine } from '../../../../helpers/functions';
import { PRICE_MAKEUP } from '../../../../constants/Define';
import {
    FormWrapperItem,
    FormWrapperInputComponent,
    DatePickerComponent
} from "../../common/component/Index";
import Input from "../../common/component/Input";
import Radio from "../../common/component/Radio";
import Wrapper from "../../common/component/Wrapper";
import Span from '../../common/component/Span';
import { Icon } from 'antd';
import moment from 'moment';
import { DATE_TIME_FORMAT } from '../../../../constants/Define';

import './PriceMakeup.less';

class PriceMakeup extends Component {

    constructor(props) {
        super(props);
        this.state = {
        };
    }

    formatNumber = (value) => {
        value += '';
        const list = value.split('.');
        const prefix = list[0].charAt(0) === '-' ? '-' : '';
        let num = prefix ? list[0].slice(1) : list[0];
        let result = '';
        while (num.length > 3) {
          result = `,${num.slice(-3)}${result}`;
          num = num.slice(0, num.length - 3);
        }
        if (num) {
          result = num + result;
        }
        return `${prefix}${result}${list[1] ? `.${list[1]}` : ''}`;
      }

    render() {
        const { t, name, value, type, disabled, validation, startDate, endDate, showName, inputClass, formatShowTime, formatDate } = this.props;
        return (
            <Wrapper className="price-makeup-section">
                <FormWrapperItem>
                    {showName &&
                        <Wrapper className={inputClass || 'col-md-4'}>
                            <FormWrapperInputComponent
                                isRequired={true}
                                isValidation={true}
                                dataValidation={name}
                                validation={validation.name}
                                labelTitle={t(`item.priceMakeup.name`)}
                            >
                                <Input placeholder="" type={`text`}
                                    disabled={disabled}
                                    className={`form-control`}
                                    name={`name`} onChange={(e) => this.props.onChangeName(e.target.value)}
                                    value={checkUndefine(name)} />
                            </FormWrapperInputComponent>
                        </Wrapper>
                    }
                    <Wrapper className={inputClass || (`${showName ? 'col-md-4' : 'col-md-6'} input-price`)}>
                        <FormWrapperInputComponent
                            isRequired={true}
                            isValidation={true}
                            dataValidation={value}
                            validation={validation.value}
                            labelTitle={t(`item.priceMakeup.title`)}
                        >

                            <Input placeholder="" 
                                // type={`currency`}
                                className={`form-control text-right`}
                                readOnly={disabled}
                                name={`value`} onChange={(e) => this.props.onChangeValue(e.target.value)}
                                value={type === PRICE_MAKEUP.TYPE.PERCENT ? value : this.formatNumber(value)}
                                prefix={
                                    <Radio.Group value={type} buttonStyle="solid"
                                        disabled={disabled}
                                        onChange={e => this.props.onChangeType(e.target.value)}>
                                        {(Object.keys(PRICE_MAKEUP.TYPE)).map(k => (
                                            <Radio.Button key={k} value={PRICE_MAKEUP.TYPE[k]}>{t(`item.priceMakeup.types.${PRICE_MAKEUP.TYPE[k]}`)}</Radio.Button>
                                        ))}
                                    </Radio.Group>
                                }
                                suffix={type === PRICE_MAKEUP.TYPE.PERCENT ? <Icon type="percentage" /> : <Span className="currencySymbol">{t(`currencySymbol`)}</Span>}
                            />
                        </FormWrapperInputComponent>
                    </Wrapper>
                    <Wrapper className={inputClass || (`${showName ? 'col-md-4' : 'col-md-6'}`)}>
                    
                        <FormWrapperInputComponent
                            isRequired={true}
                            isValidation={true}
                            dataValidation={startDate}
                            validation={validation.startDate}
                            labelTitle={t(`item.priceMakeup.applyDates`)}
                        >
                            <DatePickerComponent className={`form-control applyDates`}
                                disabled={disabled}
                                hmsComponent={`RangePicker`}
                                style={{ padding: 0, border: 0 }}
                                onChange={this.onSelectDateRange} name={`applyDates`}
                                placeholder={[t('item.priceMakeup.startDate'), t('item.priceMakeup.endDate')]}
                                value={startDate ? [startDate, endDate] : undefined}
                                showTime={formatShowTime ? formatShowTime : false}
                                format={formatDate}
                            />
                        </FormWrapperInputComponent>
                    </Wrapper>
                </FormWrapperItem>
            </Wrapper>
        );
    }

    onSelectDateRange = (data) => {
        this.props.onChangeDate(data.fullValue);
    }

}

PriceMakeup.defaultProps = {
    onChangeDate: (dateRangeArr) => { },
    onChangeName: (name) => { },
    onChangeType: (typeId) => { },
    onChangeValue: (valueNum) => { },
    showName: true,
    name: undefined,
    type: PRICE_MAKEUP.TYPE.AMOUNT,
    value: undefined,
    startDate: undefined,
    endDate: undefined,
    disabled: false,
    validation: {}
}

export default withTranslation()(PriceMakeup);
